import { HubspotConversationExportModalPayload } from './hubspotInboxExportUtils'
import { useInboxStore } from '../../../../stores/inbox/useInboxStore'

export const useInboxModals = () => {
    const { dispatch } = useInboxStore()

    const closeModal = () => {
        dispatch({ type: 'set-modal', payload: { type: null } })
    }

    const openHubspotExportModal = (payload: HubspotConversationExportModalPayload) => {
        dispatch({ type: 'set-modal', payload: { type: 'hubspot-export', payload } })
    }

    return { closeModal, openHubspotExportModal }
}
